import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const TrendingMediaSection = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetch('/projects')
      .then(res => res.json())
      .then(data => {
        const closed = data.filter(p => p.status === 'Clôturé');
        const shuffled = closed.sort(() => 0.5 - Math.random()); // aléatoire
        setProjects(shuffled.slice(0, 12)); // max 12
      })
      .catch(console.error);
  }, []);

  return (
    <section id="trending-media" className="py-5 px-3">
      <h2 className="text-center mb-4">📽️ Inspirations documentaires</h2>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: '1rem',
          justifyContent: 'center',
        }}
      >
        {projects.map((project) => {
          const randomHeight = Math.floor(Math.random() * 80) + 220; // hauteur aléatoire entre 220-300px

          return (
            <div
              key={project.id}
              style={{
                borderRadius: '12px',
                overflow: 'hidden',
                backgroundColor: '#fff',
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
              }}
            >
              {project.cover_url ? (
                <img
                  src={project.cover_url}
                  alt={project.title}
                  style={{
                    width: '100%',
                    display: 'block',
                    objectFit: 'cover',
                    height: `${randomHeight}px`,
                  }}
                />
              ) : (
                <video
                  src={`/output/project_${project.id}_final.mp4`}
                  controls
                  preload="metadata"
                  style={{
                    width: '100%',
                    display: 'block',
                    objectFit: 'cover',
                    height: `${randomHeight}px`,
                  }}
                />
              )}

              <div className="p-2">
                <h6 className="fw-bold text-truncate mb-1" title={project.title}>
                  {project.title}
                </h6>
                <p className="text-muted small text-truncate mb-2">
                  {project.description}
                </p>
                
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default TrendingMediaSection;
